import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Question } from './question';
import { SectionBody, SectionHeader, WidgetContainer } from './styles';
const textCss = "tojls5x";
const Text = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(textCss, props.className)} />;
});
export const AttendeeQuestions = ({
  invitee,
  questions
}) => {
  // Need invitee to show the "no answers" message with their name
  if (!invitee) return null;
  return <WidgetContainer>
      <SectionHeader expanded>
        {I18n.t('publisher.meeting_intelligence.details.questions.attendee_label')}
      </SectionHeader>
      <SectionBody>
        {questions?.length > 0 ? questions.map(question => <Question key={question.name} {...question} />) : <Text>
              {I18n.t('publisher.meeting_intelligence.details.questions.no_answers', {
          name: invitee.name
        })}
            </Text>}
      </SectionBody>
    </WidgetContainer>;
};

require("./attendee_questions.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./attendee_questions.js");